module.exports = __webpack_public_path__ + "img/c2-tit.42af69a6.png";